// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { TimezoneSearch } from '@/components/timezone-search';
import {
  Control,
  FieldValues,
  UseControllerProps,
  useController,
} from 'react-hook-form';

interface Props<Values extends FieldValues> extends UseControllerProps<Values> {
  /**
   * The label attached to the input element.
   */
  label: string;

  /**
   * A react-hook-form control object used to connect the input element to the
   * form.
   */
  control: Control<Values>;
}

/**
 * A controlled timezone search component that integrates with react-hook-form.
 */
export function FormTimezoneSearch<Values extends FieldValues>(
  props: Props<Values>
) {
  const { field, fieldState } = useController({
    name: props.name,
    control: props.control,
  });

  const value = field.value ?? null;

  return (
    <TimezoneSearch
      ref={field.ref}
      name={field.name}
      label={props.label}
      value={value}
      onChange={field.onChange}
      error={Boolean(fieldState.error)}
      helperText={fieldState.error?.message}
    />
  );
}
